<div class="search-panel">
    <mat-form-field floatLabel="never">
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input matInput [(ngModel)]="searchString" placeholder="Suchen..." (input)="onSearchInput()" />
    </mat-form-field>
</div>